import React from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  text,
  href,
  onClick,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg transform hover:scale-105 transition-all duration-200 inline-block text-center shadow-[0_0_20px_rgba(34,197,94,0.5),0_0_40px_rgba(34,197,94,0.3),0_0_60px_rgba(34,197,94,0.15)] hover:shadow-[0_0_25px_rgba(34,197,94,0.7),0_0_50px_rgba(34,197,94,0.4),0_0_80px_rgba(34,197,94,0.2)] animate-cta-wiggle';
  const sizeClasses = size === 'large' ? 'px-8 py-4 text-base md:text-lg' : 'px-5 py-2.5 text-sm md:text-base';
  const content = <div className="flex flex-col items-center" data-id="element-51">
      <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-green-400 mb-1 animate-pulse" data-id="element-52">
        ⚡ Acceso Inmediato
      </span>
      {href ? <a href={href} className={`${baseClasses} ${sizeClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-53">
          {text}
        </a> : <button onClick={onClick} className={`${baseClasses} ${sizeClasses} ${className} pt-[16px] pb-[16px] mt-[10px] mb-[10px]`} data-id="element-54">
          {text}
        </button>}
    </div>;
  return content;
}